import { render, staticRenderFns } from "./JourneyBrickSquare.vue?vue&type=template&id=60a85e09&scoped=true&"
import script from "./JourneyBrickSquare.vue?vue&type=script&lang=js&"
export * from "./JourneyBrickSquare.vue?vue&type=script&lang=js&"
import style0 from "../../Style/journey-brick-square.scss?vue&type=style&index=0&id=60a85e09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a85e09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a85e09')) {
      api.createRecord('60a85e09', component.options)
    } else {
      api.reload('60a85e09', component.options)
    }
    module.hot.accept("./JourneyBrickSquare.vue?vue&type=template&id=60a85e09&scoped=true&", function () {
      api.rerender('60a85e09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBrickSquare.vue"
export default component.exports